//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SettleSetting from './settle-setting.vue';

export default {
    components: {
        SettleSetting,
    },
    data() {
        return {
            submitLoading: false,

            modelVisible: false,
            channelProductList: [], // 产品列表

            channelId: '',
        };
    },
    methods: {
        open(row) {
            const { dwcode } = row;

            this.channelId = dwcode;

            this.modelVisible = true;

            this.queryData();
        },
        close() {
            this.modelVisible = false;

            this.$emit('close');
        },

        queryData() {
            this.$get(`/bhtong/channel/channelInfo/listChannelProduct/${this.channelId}`, (data) => {
                this.channelProductList = data;
            });
        },

        calcAuditStatus(key) {
            const statusMap = {
                0: {
                    label: '待审核',
                    type: 'primary',
                },
                1: {
                    label: '审核通过',
                    type: 'success',
                },
                2: {
                    label: '审核退回',
                    type: 'danger',
                },
            };

            return statusMap[key] || {};
        },
        auditHandler(row) {
            this.$prompt('请填写审核备注', '审核', {
                confirmButtonText: '通过',
                cancelButtonText: '退回',
                distinguishCancelAndClose: true,
                callback: (action, instance) => {
                    if (action === 'close') {
                        return;
                    }

                    var { inputValue } = instance,
                        shbj = 1;

                    if (action === 'cancel') {
                        shbj = 2;
                    }

                    this.$post(
                        `${this.getGetters('indexUrl')}/channel/channelInfo/auditChannelProduct`,
                        {
                            channelId: this.channelId,
                            productId: row.productId,
                            auditStatus: shbj,
                            auditRemark: inputValue,
                        },
                        () => {
                            this.queryData();
                        },
                        true,
                    );
                },
            });
        },
    },
    mounted() {},
};
